export default __webpack_public_path__ + "static/media/vespa.161142d0.svg";